const ConsoleColors = {
  get: '#6BDD9A',
  head: '#79E0A4',
  post: '#FFE47E',
  put: '#74AEF6',
  patch: '#C0A8E1',
  delete: '#F79A8E',
  options: '#F15EB0',
  url: '#F09B51',
};

export default ConsoleColors;
